//请自行添加语言资源
const coalPlanTransportVehicle = {
  plantName:"基地",
  purchOrderNo:'采购订单号',
  coalPlanNo:"外采计划单号",
  transportNo:'运输计划单',
  transportStatusName:'运输计划状态',
  carrierName:'承运商',
  closeReason: '关闭原因',
  closeOptUser: '关闭操作人',
  closeOptTime: '关闭操作时间',
  planStatusName: '外采计划单状态',
  controlWeight: '外采计划单控量',
  expirationTime: '执行到期时间',
  vehicleNo: '车牌号',
  driverName: '司机姓名',
  driverTel: '司机手机号',
  activeOff: '是否启用',
  msg:{
  }
};
export default coalPlanTransportVehicle



// WEBPACK FOOTER //
// ./src/page/bd/coal/coalPlanTransportVehicle/lang/coalPlanTransportVehicle.zh.js